import { useContext } from "react";
import { VelContext } from "@/contexts/VelContext";

export const useVelList = () => {
  const context = useContext(VelContext);
  if (!context) {
    throw new Error("useVelList must be used within a VelProvider");
  }
  return context;
};
